module.exports = __webpack_public_path__ + "assets/9ab9c1a63275c60efa64a5358b0d4883.mp3";